<template>
    <el-dialog
      title="Renew Membership"
      :visible.sync="renewModalVisible"
      width="60%"
      @close="clearRenewModal">
      <div>
        <el-row class="mt-1 mb-1 d-flex flex-align-items-center" :gutter="50">
          <el-col :span="24" class="d-flex flex-column flex-align-items-center">
            <el-progress type="circle" :percentage="renewAble ? 100 : 0" :format="() => `${renewAble ? 'Renewable' : 'Unrenewable'}`"></el-progress>
            <small class="mt-1">*Renewals are possible when registrations are 90 days from expiring</small>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="mt-1" v-if="renewalData">
          <el-row class="d-flex flex-justify-center">
            <el-col :span="12">
              <el-form ref="renewForm" :model="renewPayment" :rules="rules">
                <div>
                  <h2 class="mt--05">Payment Details</h2>
                  <el-row class="d-flex flex-align-items-center mt-15">
  <h3> {{ parsePrice(renewalData.price) }} </h3>
  <div v-if="discountData" class="ml-1">
    <el-tag type="success">
      -{{ parsePrice(discountAmount) }}
      <template v-if="discountData.type === 'percentage'">
        ({{ discountData.amount }}%)
      </template>
    </el-tag>
  </div>
</el-row>
<h3>Pay Today: {{ parsePrice(finalAmount) }}</h3>
                  <span class="description" v-if="transactionFee">*Includes a {{transactionFee}}% transaction fee</span>
                  <div v-if="renewalData.price >0">
                    <h2 class="mt--05">Credit Card Details</h2>
                    <credit-card v-model="renewPayment.card" ref="card" :width="300"/>
                    <el-divider />
                      <h3 class="f-light">Billing Address</h3>
                  <el-row :gutter="20">
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.addressLine1" label="Address Line 1">
                      <el-input class="mt-05" v-model="renewPayment.billingAddress.addressLine1" placeholder="Type here..." />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.addressLine2" label="Address Line 2">
                      <el-input class="mt-05" v-model="renewPayment.billingAddress.addressLine2" placeholder="Type here..." />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.suburb" label="City/Suburb">
                      <el-input class="mt-05" v-model="renewPayment.billingAddress.suburb" placeholder="Type here..." />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.state" label="State">
                      <el-input class="mt-05" v-model="renewPayment.billingAddress.state" placeholder="Type here..." />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.postcode" label="Postcode">
                      <el-input class="mt-05" v-model="renewPayment.billingAddress.postcode" placeholder="Type here..." />
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12" class="mt-10">
                    <el-form-item prop="billingAddress.country" label="Country">
                      <el-select
                        filterable
                        remote
                        reserve-keyword
                        class="mt-05 w-100"
                        v-model="renewPayment.billingAddress.country"
                        :remote-method="searchCountry"
                        placeholder="Select">
                        <el-option
                          v-for="item in countryItems"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                    </el-row>
                  </div>
                  <el-row>
                    <el-col :span="24" class="d-flex flex-justify-end">
                      <el-button type="secondary" @click="skipRenewPayment">Skip Payment</el-button>
                      <el-button type="primary" @click="submitRenewPayment">Make Payment</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row class="d-flex flex-justify-center">
            <el-col :span="24">
              <el-alert show-icon type="info" :title="message || 'Registration is either expired or has already been renewed'" />
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </template>

<script>
import _ from 'lodash';
import { errormsg, countries } from '@/utils/constants';
import moment from 'moment';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.input_option };
const pin = new Pin.Api(process.env.VUE_APP_PIN_PK, process.env.VUE_APP_PIN_ENV);

export default {
  name: 'RenewMembership',
  components: {
    CreditCard: () => import('@/components/CreditCard'),
  },
  props: {
    rego: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pin,
      renewModalVisible: false,
      renewalData: null,
      skipPayment: false,
      renewPayment: {
        card: {},
        billingAddress: {}
      },
      payToday: 0,
      key: 0,
      countryItems: [],
      countries,
      discountData: null,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? { required: false } : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
    };
  },
  methods: {
    openRenewModal() {
      this.$http.get(`/assemble/api/v1/admin/registrations/${this.rego._id}/renewal-options`)
        .then((res) => {
          this.renewalData = res.data.data.matchingProduct;
          this.discountData = res.data.data.matchingDiscount;
          this.renewModalVisible = true;
          if (res.data.message) {
            this.message = res.data.message;
          }
        })
        .catch(() => {
          this.$message.error('Error loading renewal options');
          this.renewModalVisible = true;
        });
    },
    clearRenewModal() {
      this.renewModalVisible = false;
      this.renewalData = {
        productId: '',
        price: 0,
        outstanding: 0,
      };
      this.renewPayment = {
        card: {},
        billingAddress: {}
      };
      this.payToday = 0;
      this.key = 0;
    },
    searchCountry(query) {
      if (query !== '') {
        setTimeout(() => {
          this.countryItems = this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
        }, 200);
      } else {
        this.countryItems = [];
      }
    },
    skipRenewPayment() {
      this.$confirm('Are you sure you want to skip the payment?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.skipPayment = true;
        this.submitRenewPayment();
      }).catch(() => {
        // User clicked No, do nothing
      });
    },
    submitRenewPayment() {
      if (this.renewalData.price <= 0 || this.skipPayment) {
        // Direct renewal without payment
        const body = {
          regoId: this.rego._id,
          productId: this.renewalData._id,
          membershipId: this.rego.entityId,
          payment: {
            total: this.skipPayment ? 0 : this.finalAmount,
            fee: this.skipPayment ? 0 : (this.finalAmount - (this.renewalData.price - this.discountAmount)),
          },
          skipPayment: this.skipPayment,
          discountId: this.discountData?._id
        };

        this.$store.commit('loading', true);
        this.$http.post(`/assemble/api/v1/admin/registrations/${this.rego._id}/renewal-payment`, body)
          .then((res) => {
            const renewedRego = res.data.data;
            this.$message.success('Renewal successful');
            this.clearRenewModal();
            this.$emit('renewed', renewedRego);
            this.$store.commit('loading', false);
          })
          .catch(() => {
            this.$store.commit('loading', false);
            this.$message.error('Renewal failed');
          });
        return;
      }
      Promise.all([this.$refs.card?.validate(), this.$refs.renewForm?.validate()])
        .then(([cardValid, formValid]) => {
          if (!cardValid || !formValid) return;

          // issue card token
          const [expiryMonth, expiryYear] = this.renewPayment.card.expiry.replace(/\s/g, '').split('/');

          console.log('validated');
          this.$store.commit('loading', true);
          this.pin.createCardToken({
            number: this.renewPayment.card.number,
            name: this.renewPayment.card.name,
            expiry_month: expiryMonth,
            expiry_year: expiryYear,
            cvc: this.renewPayment.card.cvc,
            address_line1: this.renewPayment.billingAddress.addressLine1,
            address_line2: this.renewPayment.billingAddress.addressLine2 || '',
            address_city: this.renewPayment.billingAddress.suburb,
            address_state: this.renewPayment.billingAddress.state,
            address_postcode: this.renewPayment.billingAddress.postcode,
            address_country: 'Australia',
          }).then((pinResponse) => {
            // eslint-disable-next-line camelcase
            const { token, issuing_country } = pinResponse;
            // eslint-disable-next-line camelcase
            if (issuing_country !== 'AU') {
              this.$store.commit('loading', false);
              this.$message.error('Payment method not supported.');
              return;
            }

            if (!token) {
              this.$store.commit('loading', false);
              this.$message.error('There has been an error, try again later.');
              return;
            }

            // Make payment using the obtained charge token
            const body = {
              regoId: this.rego._id,
              productId: this.renewalData._id,
              membershipId: this.rego.entityId,
              payment: {
                total: this.finalAmount,
                fee: this.finalAmount - (this.renewalData.price - this.discountAmount),
              },
              discountId: this.discountData?._id,
              chargeToken: token,
              billingAddress: this.renewPayment.billingAddress,
            };
            this.$http.post(`/assemble/api/v1/admin/registrations/${this.rego._id}/renewal-payment`, body)
              .then((res) => {
                const renewedRego = res.data.data;
                this.$message.success('Payment successful');
                this.clearRenewModal();
                this.$emit('renewed', renewedRego);
                this.$store.commit('loading', false);
              })
              .catch(() => {
                this.$message.error('Payment failed');
              });
          }).catch((err) => {
            this.$store.commit('loading', false);
            const pinError = _.get(err, 'error_description');
            this.$message.error(pinError || 'There has been an error');
          });
        }).catch((errValidate) => {
          this.$store.commit('loading', false);
          this.$message.error(errValidate);
        });
    },
    dateFormatter(r, c, v) {
      return v ? moment(v).format('YYYY-MM-DD HH:mm') : '';
    },
    priceFormatter(r, c, v) {
      return v ? `$${(v / 100).toFixed(2)}` : '';
    },
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    getSummaries() {
      return [`Total: $${(this.renewalData.amountPaid / 100)}`];
    },
  },
  computed: {
    transactionFee() {
      const defaultFee = +this.$store.getters['national/transactionFee'];
      const preferredFee = +this.$store.getters['national/paymentPreference'].addToTotal;
      return !(preferredFee >= 0) ? defaultFee : preferredFee;
    },
    renewalProgress() {
      const { createdAt, expiry } = this.rego;
      const totalDuration = moment(expiry).diff(moment(createdAt), 'days');
      const elapsedDuration = moment().diff(moment(createdAt), 'days');
      return Math.min((elapsedDuration / totalDuration) * 100, 100);
    },
    minPayment() {
      const { outstanding } = this.renewalData;
      return outstanding > 100 ? 100 : outstanding;
    },
    payTodayTotal() {
      const { payToday } = this;
      console.log(payToday, this.transactionFee);
      return +(payToday + ((payToday * this.transactionFee) / 100)).toFixed() || 0;
    },
    renewalProgressDay() {
      const { createdAt, expiry } = this.rego;
      const totalDuration = moment(expiry).diff(moment(createdAt), 'months');
      const elapsedDuration = moment().diff(moment(createdAt), 'months');
      return `${elapsedDuration} / ${totalDuration}`;
    },
    elapsedMonths() {
      const { createdAt } = this.rego;
      return moment().diff(moment(createdAt), 'months');
    },
    totalMonths() {
      const { expiry } = this.rego;
      return moment(expiry).diff(moment(), 'months');
    },
    renewAble() {
      return this.renewalData && this.totalMonths - this.elapsedMonths <= 6;
    },
    discountAmount() {
      if (!this.discountData) return 0;

      // eslint-disable-next-line no-nested-ternary
      return this.discountData.type === 'dollar'
        ? this.discountData.amount
        : this.discountData.type === 'percentage'
          ? Math.floor((this.renewalData.price * this.discountData.amount) / 100)
          : 0;
    },

    finalAmount() {
      const discountedPrice = this.renewalData.price - this.discountAmount;
      return discountedPrice + ((discountedPrice * this.transactionFee) / 100);
    }
  },
};
</script>

<style lang="scss" scoped>
.price-divider {
  padding: 0 0.5rem;
}
</style>
